export default function ChangePasswordValidation(values: any) {
  let errors: any = {};

  if (!values.current_password) {
    errors.current_password = "La contraseña actual es requerida";
  }

  if (!values.password) {
    errors.password = "La nueva contraseña es requerida";
  }

  if (!values.password || values.password.length < 8) {
    errors.minimum = true;
  }

  if (!/\d+/.test(values.password)) {
    errors.number = true;
  }

  if (!/[A-Z]+/.test(values.password)) {
    errors.uppercase = true;
  }

  if (values.password !== values.password_confirmation) {
    errors.password_confirmation = "Las contraseñas deben ser iguales";
  }
  
  return errors;
}
